import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["name", "iconSet", "className", "size"];
import React from "react";
import PropTypes from "prop-types";
import baseCss from "../../css/base.css";
import defaultIconSet from "../../icon-sets/v2/index.js";
/**
 * Component used to render a non interactive icon based on the definitions in the loaded icons fragment
 */

var Icon = function Icon(_ref) {
  var name = _ref.name,
      iconSet = _ref.iconSet,
      className = _ref.className,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _iconSet$resolve = iconSet.resolve(name),
      id = _iconSet$resolve.id,
      ownClassName = _iconSet$resolve.className;

  var classes = [baseCss.icon, size ? baseCss["size-".concat(size)] : baseCss['icon-has-no-size'], className, ownClassName];
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: classes.join(' ')
  }, rest), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(id)
  }));
};

process.env.NODE_ENV !== "production" ? Icon.propTypes = {
  /**
   * Name of the icon. Used to look up in the given iconSet
   */
  name: PropTypes.string.isRequired,

  /**
   * Additional class to append to icon container
   */
  className: PropTypes.string,

  /**
   * An abstraction that knows how to resolve an icon name to the icon props. Will use the default export from `/lib/icon-sets` if not provided.
   */
  iconSet: PropTypes.shape({
    resolve: PropTypes.func
  }),

  /**
   * A size class. See the size table for more info.
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
} : void 0;
Icon.defaultProps = {
  className: '',
  iconSet: defaultIconSet,
  size: null
};
export default Icon;